import {
  Button,
  makeStyles,
  Slider,
  useMediaQuery,
  useTheme,
  withStyles,
} from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import { QKey, useAnswerContext } from '../../../context';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Animation } from '../../animation/animation';

export const useStyles = makeStyles((theme) => ({
  header: {
    fontWeight: 500,
    color: 'rgb(32,33,36)',
    margin: 0,
    [theme.breakpoints.down('md')]: {
      fontSize: 28,
      lineHeight: '40px',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 38,
      letterSpacing: -0.43,
      lineHeight: '52px',
      maxWidth: 440,
    },
  },
  button: {
    background: '#e8f0fe',
    color: '#1967d2',
    '&:hover': {
      background: '#e8f0fe',
    },
    [theme.breakpoints.down('md')]: {
      marginRight: 20,
      flex: 1,
    },
    [theme.breakpoints.up('md')]: {
      marginRight: 50,
    },
  },
  info: {
    fontSize: 18,
    letterSpacing: 0.4,
    lineHeight: '52px',
    fontWeight: 500,
    marginTop: 20,
    color: '#9AA0A6',
    maxWidth: 600,
    margin: 0,
  },
  selectContainer: {
    margin: '30px 0 10px',
    display: 'flex',
    flexWrap: 'wrap',
    [theme.breakpoints.up('md')]: {
      maxWidth: 560,
    },
  },
  selectContainer2: {
    margin: '30px 0 10px',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    [theme.breakpoints.up('md')]: {
      maxWidth: 540,
    },
  },
  rankContainer: {
    border: '1px solid #DADCE0',
    borderRadius: '6px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: 20,
    cursor: 'pointer',
    lineHeight: '26px',
    fontSize: '15px',
    fontFamily: 'Roboto',
    color: '#1A73E8',
    boxSizing: 'border-box',
    [theme.breakpoints.up('md')]: {
      maxWidth: 500,
    },
    position: 'absolute',
    width: '100%',
    transition: 'transform 0.3s ease-In',
  },
  rankNumber: {
    width: '25px',
    height: '25px',
    background: '#F1F3F4',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 14,
    fontWeight: 500,
    borderRadius: 4,
    margin: 10,
  },
  textAreaStyle: {
    width: '100%',
    background: '#F8F9FA',
    overflow: 'auto',
    border: 'none',
    fontFamily: 'Roboto, sans-serif',
    fontSize: '15',
    letterSpacing: '0.08px',
    lineHeight: '26px',
    resize: 'none',
    '&:focus': {
      outline: '1px solid transparent',
    },
    '&::placeholder': {
      fontFamily: 'Roboto, sans-serif',
      fontSize: '15',
      letterSpacing: '0.08px',
      lineHeight: '26px',
    },
  },
  buttonAnswer: {
    marginBottom: 20,
    textAlign: 'left',
    background: '#fff',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      padding: '12px 24px',
    },
    [theme.breakpoints.up('md')]: {
      padding: '12px 24px',
      marginRight: 20,
      width: 'auto',
    },
    color: '#1a73e8',
    fontSize: 16,
    border: '1px solid #dadce0',
    lineHeight: '24px',
    fontWeight: 500,
    borderRadius: 4,
    justifyContent: 'flex-start',
    '&:focus': {
      boxShadow: 'rgb(26 115 232) 0px 0px 0px 2px',
    },
    '&:hover': {
      background: '#fff',
      borderColor: '#1a73e8',
      boxShadow:
        'rgb(60 64 67 / 30%) 0px 1px 2px 0px, rgb(60 64 67 / 15%) 0px 1px 3px 1px',
    },
  },
  choosenButtonAnswer: {
    marginBottom: 20,
    background: '#f2f7fe',
    color: '#1a73e8',
    fontSize: 16,
    border: '1px solid #1a73e8',
    lineHeight: '24px',
    fontWeight: 500,
    justifyContent: 'flex-start',
    textAlign: 'left',
    borderRadius: 4,
    [theme.breakpoints.down('md')]: {
      width: '100%',
      padding: '12px 24px',
    },
    [theme.breakpoints.up('md')]: {
      padding: '12px 24px',
      marginRight: 20,
      width: 'auto',
    },
    '&:hover': {
      borderColor: '#1a73e8',
      boxShadow:
        'rgb(60 64 67 / 30%) 0px 1px 2px 0px, rgb(60 64 67 / 15%) 0px 1px 3px 1px',
    },
    '&:focus': {
      boxShadow: 'rgb(26 115 232) 0px 0px 0px 2px',
    },
  },
  listItem: {
    border: '1px solid #ff0000',
  },
}));

const CustomSlider = withStyles({
  rail: {
    height: 6,
    borderRadius: 3,
  },
  root: {
    marginTop: 50,
    marginBottom: 50,
    height: 6,
    borderRadius: 3,
    maxWidth: 434,
  },
  track: {
    height: 6,
    borderRadius: 3,
  },
  valueLabel: {
    left: 'calc(-50% - 8px)',
    height: 20,
    fontSize: '18px',
  },
  mark: {
    backgroundColor: '#1a73e8;',
    height: 6,
    width: 6,
    borderRadius: 3,
    marginTop: 0,
    marginLeft: -3,
  },
  markActive: {
    backgroundColor: '#fff',
    marginLeft: 0,
  },
  active: {},
  thumb: {
    height: 12,
    width: 12,
    backgroundColor: '#1a73e8',
    border: '2px solid currentColor',
    marginTop: -3,
    marginLeft: -4,
  },
})(Slider);

const grid = 20;

const getItemStyle = (
  isDragging: boolean,
  draggableStyle: any,
  isActive: boolean,
  isMobile: boolean,
  isOther: boolean,
) => ({
  userSelect: 'none',
  padding: !isOther ? '10px 18px' : 0,
  color: 'rgb(26, 115, 232)',
  margin: `0 0 ${grid}px 0`,
  background: '#fff',
  opacity: !isActive || isDragging ? 1 : 0.5,
  borderRadius: 6,
  width: isMobile ? '100%' : 440,
  fontFamily: 'Roboto, sans-serif',
  fontSize: '15px',
  letterSpacing: '0.08px',
  lineHeight: '26px',
  backgroundImage: !isOther
    ? 'linear-gradient(rgb(218, 220, 224), rgb(218, 220, 224)), linear-gradient(rgb(218, 220, 224), rgb(218, 220, 224))'
    : undefined,
  backgroundSize: '16px 2px, 16px 2px',
  backgroundPosition:
    'calc(100% - 14px) calc(50% + 2px), calc(100% - 14px) calc(50% - 2px)',
  backgroundRepeat: 'no-repeat',
  boxShadow: isDragging
    ? '0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 5px 8px 0px rgb(0 0 0 / 14%), 0px 1px 14px 0px rgb(0 0 0 / 12%)'
    : 'rgb(54 64 67 / 0%) 0px 1px 3px 0px, rgb(54 64 67 / 0%) 0px 4px 8px 3px',

  border: isDragging ? '1px solid #1a73e8' : '1px solid rgb(218, 220, 224)',
  transition:
    'box-shadow 2s ease-in-out 0s, border 0.2s ease-in-out 0s, color 0.2s ease-in-out 0s',

  ...draggableStyle,
});

const getListStyle = (isMobile: boolean) => ({
  padding: 0,
  width: isMobile ? '100%' : 250,
  marginTop: 20,
  marginBottom: 40,
});

export interface IBaseQuestion {
  onNext: () => void;
  onPrevious: () => void;
  isPreviousDisabled: boolean;
  nextText?: string;
  animatedImage?: JSX.Element;
}

export interface IQuestion {
  headerText: string;
  help: string;
  questionKey: QKey;
  type: 'slider' | 'order' | 'select' | 'select-fw' | 'rank' | 'multi-select';
  options?: Array<{ text: string; value: number }>;
}

const Other: React.FC<{
  id: string;
  hidden?: boolean;
  order?: boolean;
  rank?: boolean;
  isSingleSelect?: boolean;
}> = ({
  id,
  hidden = true,
  order = false,
  rank = false,
  isSingleSelect = false,
}) => {
  const [isHidden, hide] = useState(hidden);
  const inputRef = useRef<HTMLTextAreaElement>(null);
  const [text, setText] = useState(sessionStorage.getItem(id) ?? '');
  const { textAreaStyle } = useStyles();
  useEffect(() => {
    if (!hidden) {
      return;
    }
    if (!inputRef.current) {
      return;
    }
    const el = inputRef.current!;
    const f = (evt: FocusEvent) => {
      if (!el.value) hide(true);
    };
    el.addEventListener('blur', f);
    return () => {
      el.removeEventListener('blur', f);
    };
  }, [hidden]);

  useEffect(() => {
    sessionStorage.setItem(id, text);
  }, [text, id]);

  useEffect(() => {
    const text = sessionStorage.getItem(id);
    if (text || rank) {
      setText(text ?? '');
      hide(false);
    }
  }, [id, rank]);

  useEffect(() => {
    if (!isHidden) {
      inputRef.current!.focus();
    }
  }, [isHidden]);
  useEffect(() => {
    if (rank || !hidden) {
      return;
    }
    const f = () => {
      if (!inputRef.current) {
        return;
      }
      const el = inputRef.current!;
      if (!el.value) {
        hide(true);
      }
    };
    document.addEventListener('click', f);

    return () => {
      document.removeEventListener('click', f);
    };
  }, [rank, hidden]);

  return (
    <div
      style={{ flex: 1 }}
      onClick={(ev) => {
        ev.stopPropagation();
        hide(false);
      }}
    >
      <div
        style={{
          backgroundImage: hidden
            ? 'linear-gradient(rgb(218, 220, 224), rgb(218, 220, 224)), linear-gradient(rgb(218, 220, 224), rgb(218, 220, 224))'
            : 'none',
          backgroundSize: '16px 2px, 16px 2px',
          backgroundPosition:
            'calc(100% - 14px) calc(50% + 2px), calc(100% - 14px) calc(50% - 2px)',
          backgroundRepeat: 'no-repeat',
        }}
      >
        Other
      </div>
      {isHidden ? null : (
        <Animation animationKey={isHidden} onlyFade>
          <div
            style={{
              minWidth: text === 'Other' ? 260 : undefined,
              background: isSingleSelect ? '#fff' : '#F8F9FA',
            }}
          >
            <textarea
              rows={2}
              tabIndex={0}
              ref={inputRef}
              placeholder="Type here..."
              value={text}
              style={{
                backgroundColor: isSingleSelect ? '#fff' : undefined,
              }}
              className={textAreaStyle}
              onChange={(e) => {
                setText(e.target.value);
                e.nativeEvent.stopImmediatePropagation();
              }}
            />
          </div>
        </Animation>
      )}
    </div>
  );
};

const Answer: React.FC<{
  type: 'slider' | 'order' | 'select' | 'select-fw' | 'rank' | 'multi-select';
  questionKey: QKey;
  options?: Array<{ text: string; value: number }>;
}> = ({ type, options, questionKey }) => {
  const {
    buttonAnswer,
    choosenButtonAnswer,
    selectContainer,
    selectContainer2,
    rankNumber,
    rankContainer,
  } = useStyles();
  const { values, setValue } = useAnswerContext();
  const theme = useTheme();
  const matches = !useMediaQuery(theme.breakpoints.up('md'));
  const small = useMediaQuery(theme.breakpoints.down('xs'));
  const val = values[questionKey];
  const other = {
    id: '',
    hidden: false,
    order: false,
    rank: false,
  };

  const [show, hide] = useState(other);

  useEffect(() => hide(other), []);

  if (type === 'slider') {
    return (
      <CustomSlider
        defaultValue={3}
        aria-labelledby="discrete-slider"
        valueLabelDisplay="auto"
        style={matches ? { margin: '30px 0 10px' } : undefined}
        step={1}
        marks
        min={1}
        max={5}
        value={val as number}
        onChange={(_, num) => setValue(questionKey, num as number)}
      />
    );
  }
  if (type === 'select' && options) {
    return (
      <div className={selectContainer}>
        {options.map(({ text, value }) =>
          text === 'Other' && value === val ? (
            <div
              style={{
                justifyContent: 'flex-start',
                minWidth: text === 'Other' ? 260 : undefined,

                marginRight: text === 'Other' ? 50 : undefined,
              }}
              className={value === val ? choosenButtonAnswer : buttonAnswer}
              key={value}
              onClick={() => setValue(questionKey, value)}
            >
              <Other
                key={value}
                id={`other${questionKey}`}
                isSingleSelect={true}
                hidden={false}
              />
            </div>
          ) : (
            <Button
              className={value === val ? choosenButtonAnswer : buttonAnswer}
              key={value}
              style={{
                justifyContent: 'flex-start',
                marginRight: text === 'Other' ? 50 : undefined,
                minWidth: text === 'Other' ? 260 : undefined,
              }}
              onClick={() => setValue(questionKey, value)}
            >
              {text}
            </Button>
          ),
        )}
      </div>
    );
  }

  if (type === 'select-fw' && options) {
    return (
      <div className={selectContainer}>
        {options.map(({ text, value }) => (
          <Button
            style={{ width: '100%', justifyContent: 'flex-start' }}
            className={value === val ? choosenButtonAnswer : buttonAnswer}
            key={value}
            onClick={() => setValue(questionKey, value)}
          >
            {text}
          </Button>
        ))}
      </div>
    );
  }

  if (type === 'multi-select' && options) {
    return (
      <div className={selectContainer2}>
        {options.map(({ text, value }) =>
          text === 'Other' && (val as number[]).includes(value) ? (
            <div
              style={{
                justifyContent: 'flex-start',
              }}
              className={
                (val as number[]).includes(value)
                  ? choosenButtonAnswer
                  : buttonAnswer
              }
              key={value}
              onClick={() => setValue(questionKey, value)}
            >
              <Other
                key={value}
                id={`other${questionKey}`}
                isSingleSelect={false}
                hidden={false}
              />
            </div>
          ) : (
            <Button
              style={{
                justifyContent: 'flex-start',
                minWidth: text === 'Other' ? 260 : undefined,
              }}
              className={
                (val as number[]).includes(value)
                  ? choosenButtonAnswer
                  : buttonAnswer
              }
              key={value}
              onClick={() => setValue(questionKey, value)}
            >
              {text}
            </Button>
          ),
        )}
      </div>
    );
  }

  if (type === 'order' && options && Array.isArray(val)) {
    return (
      <DragDropContext
        onDragEnd={(result) => {
          if (!result.destination) {
            return;
          }

          const reorder = (
            list: Array<number>,
            startIndex: number,
            endIndex: number,
          ) => {
            const result = Array.from(list);
            const [removed] = result.splice(startIndex, 1);
            result.splice(endIndex, 0, removed);

            return result;
          };

          const items = reorder(
            val as number[],
            result.source.index,
            result.destination.index,
          );

          setValue('q2', items as any);
        }}
      >
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              style={getListStyle(matches)}
            >
              {(val as number[]).map((item, index) => {
                const { draggingOverWith } = snapshot;
                if (item > options.length) {
                  return null;
                }
                return (
                  <Draggable
                    key={item}
                    draggableId={'drag' + item}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style,
                          draggingOverWith !== null,
                          matches,
                          options.find((x) => x.value === item)?.text ===
                            'Other',
                        )}
                      >
                        {options.find((x) => x.value === item)?.text ===
                        'Other' ? (
                          <Other id={'other' + questionKey} order={true} />
                        ) : (
                          options.find((x) => x.value === item)?.text
                        )}
                      </div>
                    )}
                  </Draggable>
                );
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }
  if (type === 'rank' && options) {
    const ranked = options.map((x) => ({
      ...x,
      rank: (val as any[]).find((y) => y.id === x.value)?.rank ?? 100,
    }));
    ranked.sort((a, b) => a.rank - b.rank);
    const protocolSub = ranked.find((x) => x.value === 4)!;
    const idx = ranked.indexOf(protocolSub);
    const flow2 = false;
    return (
      <div
        style={{
          position: 'relative',
          marginBottom: 40,
          boxSizing: 'border-box',
          height:
            options.length * 65 + (show ? 90 : 0) + (small && flow2 ? 30 : 0),
        }}
      >
        {ranked.map((x, i) => (
          <div
            key={x.value}
            className={rankContainer}
            style={{
              height:
                x.value === 7 && x.rank < 100
                  ? 135
                  : x.value === 4 && small && flow2
                  ? 75
                  : 45,
              transform: `translateY(${
                i * 65 +
                ((other?.rank || 200) < x.rank
                  ? 90
                  : idx < i && small && flow2
                  ? 30
                  : 0)
              }px)`,
            }}
          >
            <span
              className={rankNumber}
              onClick={() => {
                setValue('q3', x.value);
              }}
            >
              {x.rank !== 100 ? x.rank : ''}
            </span>
            {x.value === 7 && x.rank < 100 ? (
              <Other id="otherq3" hidden={false} rank />
            ) : (
              <div style={{ flex: 1 }}>{x.text}</div>
            )}
          </div>
        ))}
      </div>
    );
  }
  return null;
};

export const BaseQuestion: React.FC<IBaseQuestion & IQuestion> = ({
  onNext,
  onPrevious,
  isPreviousDisabled,
  headerText,
  help,
  questionKey,
  animatedImage,
  nextText,
  ...rest
}) => {
  const { button, header, info } = useStyles();
  const { values, setValue } = useAnswerContext();
  const isFlow2 = false;
  const val = values[questionKey];
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <div>
      <h2
        className={header}
        style={{
          maxWidth: matches
            ? '100%'
            : questionKey === 'q1'
            ? 540
            : questionKey === 'q2'
            ? 540
            : questionKey === 'q3'
            ? 540
            : questionKey === 'q4'
            ? 480
            : questionKey === 'q5' && isFlow2
            ? 420
            : questionKey === 'q5'
            ? 480
            : questionKey === 'q6' && isFlow2
            ? 400
            : questionKey === 'q6'
            ? 480
            : questionKey === 'q7'
            ? 520
            : 440,
        }}
      >
        {headerText}
      </h2>
      <p
        className={info}
        style={{
          lineHeight: '32px',
          paddingTop: '15px',
        }}
      >
        {help}
      </p>
      <div>
        <Answer {...rest} questionKey={questionKey} />
      </div>
      {animatedImage ? (
        <div
          style={{
            position: 'relative',
            width: '100%',
            height: 250,
            maxWidth: 350,
            // transform: 'scale(0.7)',
            margin: '0 auto',
          }}
        >
          {animatedImage}
        </div>
      ) : null}
      <div
        style={{
          display: 'flex',
          justifyContent: matches ? 'center' : 'flex-start',
          marginTop:matches ? 0 : 50,
        }}
      >
        <Button
          variant="contained"
          className={button}
          onClick={onPrevious}
          disabled={isPreviousDisabled}
        >
          {matches ? 'Previous' : 'Previous question'}
        </Button>
        <Button
          color="primary"
          variant="contained"
          style={{ flex: matches ? 1 : undefined }}
          onClick={() => {
            setValue(questionKey, val as any);
            onNext();
          }}
          disabled={Array.isArray(val) ? val.length < 1 : val < 1}
        >
          {nextText ?? (matches ? 'Next' : 'Next question')}
        </Button>
      </div>
    </div>
  );
};
